module.exports = "/images/vendor/flag-icon-css/flags/1x1/mq.svg?a09e48650a204ba97073a30c5510f63f";